export default "__VITE_ASSET__C_gHdE8n__"